export default __webpack_public_path__ + "static/media/04-bauble.b31e276e.svg";